module.exports = __webpack_public_path__ + "img/check-connection.ceb79b17.png";